module.exports = __webpack_public_path__ + "img/shuttle-central.09d514f4.png";